import styled from "styled-components";

export const Advertisement = styled.a`
  background: #ffffff;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  width: 100%;
  height: 105px;
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  margin-bottom: 10px;
  font-family: "Avenir Next";
  text-decoration: none;
`;

export const AdvertisementIcon = styled.img`
  height: 65px;
  width: 65px;
  margin-right: 16px;
`;

export const AdvertisementTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AdvertisementHeaderText = styled.p`
  font-size: 18px;
  color: #2D2D2D;
  margin-bottom: 10px;  
`;

export const AdvertisementBodyText = styled.p`
  font-size: 20px;
  color: #3C3C3C;
  font-weight: bold;
`;

export const ArrowRight = styled.img`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 17px;
  top: 40px;
`;